import { useEffect, useState } from "react";
import { ErrorContext } from "../../utils/context/error";
import { getServiciosPend } from "../../services/servicios";
import Icon from "../../Icons/general/Icon";
import LlamarPendModal from "./llamarpmodal";

function Pendiente() {
  const [AreaId, setArea] = useState(0);
  const [Periodo, setPeriodo] = useState(0);
  const [Turno, setTurno] = useState(0);
  const [Item, setItem] = useState(0);
  const [ListPendiente, setPendiente] = useState([]);
  const [Modulo, setModulo] = useState([]);
  const [showM, setShowM] = useState(false);
  const { setShowToast, setOpciones } = ErrorContext();
  const [selectedRow, setSelectedRow] = useState(null);

  //---- Metodo que obtiene el listado de turnos pendientes
  const fillPendientes = async () => 
    {
      const response = await getServiciosPend();
      if (response) 
        {
          if (response.status === 200) 
            {
               setModulo(response.data.modulo[0]);
               setPendiente(response.data.data);
            } 
          else 
          {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
         }
       }
   };
  
  //---- Boton Atender paciente
  const handleTurno = async (item) => 
    {
      const PeriodoId = item.PeriodoId;
      const TurnoId = item.TurnoId
      const ItemId = item.ItemId;
      const AreaI = item.AreaId;

      setPeriodo(PeriodoId);
      setTurno(TurnoId);
      setItem(ItemId);
      setArea(AreaI);
      setShowM(true);
    };

  //---------------
  const handlefilas = (Item, index) => 
    {
      setSelectedRow(index);
    };

   //----Llamada al iniciar
   
  useEffect(() => 
    {
     fillPendientes();
    
    }, []);

  return (
    <>
      <div className="flex flex-col w-full h-min">
         <div className="flex flex-row w-full border-b border-stone-200 justify-between pb-1">
            <div className="text-left text-[1.09rem] font-medium text-gray-500">Turno Pendientes</div>
            <div className="text-right text-[1.09rem] font-medium text-gray-500">
               <span>Modulo  </span> 
                <span>{Modulo.CodigoMod}</span>
            </div>
          </div>
          <div className="mt-2 rounded-lg border border-stone-200">
              <table className="w-full table-auto">
                  <thead className="border-b border-stone-200 text-sm font-medium ">
                     <tr>
                         <th className="hidden md:table-cell px-2.5 py-2 text-start font-medium">#</th>
                         <th className="px-2.5 py-2 text-start font-medium">
                           <span className="block lg:hidden">Serv.</span>
                           <span className="hidden lg:block">Servicio</span>
                         </th>
                         <th className="px-2.5 py-2 text-start font-medium">
                           <span className="block lg:hidden">Pref.</span>
                           <span className="hidden lg:block">Prefijo</span>
                         </th>
                         <th className="px-2.5 py-2 text-start font-medium">
                           <span className="block lg:hidden">Cons.</span>
                           <span className="hidden lg:block">Consecutivo</span>
                         </th>
                         <th className="px-2.5 py-2 text-start font-medium">Modulo</th>
                         <th className="px-2.5 py-2 text-start font-medium">Estado</th>
                         <th className="px-2.5 py-2 text-start font-medium">Atender</th>
                     </tr>
                  </thead>
                  <tbody className="group text-sm text-stone-800 ">
                     {ListPendiente.map((item, index) => {
                          return (
                             <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={index} id={`fila${item.MedicoId}`} onClick={() => handlefilas(item, index)}>
                                <td className="hidden md:table-cell">
                                  <div className="flex items-center gap-3 text-sm text-current">
                                     {item.ItemId}
                                  </div>
                               </td>
                               <td>{item.NombreServ}</td>
                               <td>{item.Prefijo}</td>
                               <td>{item.Consecutivo}</td>
                               <td>{item.CodigoMod}</td>
                               <td >{item.Estado === "AC" ? 
                                      (<div>
                                         <span className="tagac block lg:hidden">AC</span>
                                         <span className="tagac hidden lg:block">Por Atender</span>
                                       </div>  
                                      ) : 
                                      (item.Estado === "PE" ? 
                                        (
                                          <div>
                                             <span className="tagan block lg:hidden">PE</span>
                                             <span className="tagan hidden lg:block">Pendiente</span>
                                          </div> 
                                        )  
                                        :
                                        (item.Estado === "CE" ? 
                                          (
                                            <div>
                                               <span className="tagce block lg:hidden">CE</span>
                                               <span className="tagce hidden lg:block">Atendido</span>
                                            </div> 

                                          )
                                          :(item.Estado === "SU" ? 
                                            (
                                              <div>
                                                 <span className="tagsu block lg:hidden">SU</span>
                                                 <span className="tagsu hidden lg:block">En Proceso</span>
                                              </div> 

                                            ):''
                                          )
                                        )
                                       )
                                    }
                                 </td>
                                 
                               <td>
                                   <div className={`flex w-[2.5rem] h-[2.5rem] items-center justify-center border rounded-full 
                                                   group ${item.Estado !== "CE" ? 'border-default hover:cursor-pointer hover:bg-body hover:border-gray-600':'bg-gray-200 opacity-50 pointer-events-none'}`} 
                                        id={`btn${item.TurnoId}${item.ItemId}`}
                                        onClick={() => item.Estado !== "CE" && handleTurno(item)}>
                                       <Icon svg="phone" className={`w-[1.3rem] h-[1.3rem] ${item.Estado !== "CE" ? 'fill-default group-hover:fill-gray-600':'fill-gray-200'}`} title="phone" />
                                    </div>
                               </td>
                             </tr>
                  )})}
                 
               </tbody>
             </table>
             </div>
      </div>

      <LlamarPendModal
        show={showM}
        PeriodoId={Periodo}
        TurnoId={Turno}
        ItemId={Item}
        AreaId={AreaId}
        handleshow={setShowM}
        fillPendientes={fillPendientes}
      ></LlamarPendModal>
    </>
  );
}
export default Pendiente;
